/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Config, ConfigOptions } from '@forgerock/javascript-sdk';
import { configOptions } from './config';
import { applyPolyfills, defineCustomElements } from '@utdx/rotor-web-components/dist/loader';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import  '@utdx/theme-variables/pratt/pratt.scss';
import './stepper.scss';

applyPolyfills().then(function () {
  defineCustomElements(window)
});


Config.set(configOptions as ConfigOptions);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <Provider store={store}>
      <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
